module.exports = "https://img1.zhuanstatic.com/platform/zz-universal-pages/static/img/bad_selected.3d581f78.gif";